module.exports = __webpack_public_path__ + "media/42.9f0b89e0.wav";